// The email + password method on the entry screen (FR-001, FR-003; P-AUTH-4): Log in and Sign up,
// each carrying the sanitised returnTo so signing in returns to the requested page (001 FR-013).
import { Link, useLocalSearchParams } from "expo-router";
import { StyleSheet, View } from "react-native";

import { sanitizeReturnTo } from "@/session/access";
import type { SignInMethod } from "@/session/types";
import { makeStyles } from "@/theme/makeStyles";
import { Button } from "@/ui/Button";

import { AUTH_COPY } from "../copy";
import { AUTH_CARD_MAX_WIDTH } from "../ui/AuthCard";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    actions: {
      gap: t.space.md,
      alignSelf: "stretch",
      maxWidth: AUTH_CARD_MAX_WIDTH,
      width: "100%",
    },
  }),
);

export function EmailPasswordEntry() {
  const styles = useStyles();
  const { returnTo } = useLocalSearchParams<{ returnTo?: string }>();
  const safe = sanitizeReturnTo(typeof returnTo === "string" ? returnTo : null);
  const params = safe ? { returnTo: safe } : {};
  return (
    <View style={styles.actions}>
      <Link href={{ pathname: "/login", params }} asChild>
        <Button accessibilityRole="link">{AUTH_COPY.actions.logIn}</Button>
      </Link>
      <Link href={{ pathname: "/sign-up", params }} asChild>
        <Button accessibilityRole="link" variant="outline">
          {AUTH_COPY.actions.signUp}
        </Button>
      </Link>
    </View>
  );
}

export const emailPasswordMethod: SignInMethod = {
  id: "email-password",
  label: "Email and password",
  EntryComponent: EmailPasswordEntry,
};
